<template>
  <div class="rounded-lg bg-dark-modal mt-4 p-3 text-center d-flex flex-column align-items-center text-white justify-content-center">
    <p>Você marcou</p>
    <Alternative
      :type="question.answer.toLowerCase() === (question.user_answer ? question.user_answer.toLowerCase() : '') ? 'success' : 'danger'"
      :answered="question.user_answer ? question.user_answer : ''"
    />
    <p
      v-show="!question.invalidated"
      class="mt-3"
    >
      Alternativa correta
    </p>
    <Alternative
      v-if="!question.invalidated"
      type="success"
      :answered="question.answer"
    />
  </div>
</template>
<script>
import Alternative from "./Alternative.vue"

export default {
  components:{
    Alternative,
  },
  props:{
    question:{
      type: Object,
      required: true,
    }
  }
}
</script>

